




















































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import { Claim, ClaimType, FetchState } from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { toLower } from "lodash";
import LinkExpense from "@/shared/components/expenseV2/LinkExpense.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import LinkedExpenseRow from "@/employee/components/healthcareExpenseV2/LinkedExpenseRow.vue";
import { claimTypeIcon } from "@/shared/awesomeIconMapper";
import { useClaimStore } from "@/employee/store/claim";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    Pill,
    Button,
    CurrencyAmount,
    LinkExpense,
    LinkedExpenseRow,
    GenericLoadingSpinner
  },
})
export default class ClaimDetail extends Vue {
  claimTypeIcon = claimTypeIcon;
  claimStore = useClaimStore();
  themeStore = useThemeStore();

  @Prop() claim: Claim;

  @Prop({ required: true })
  onClaimExpenseLink: (claimNumber: string) => void;

  @Prop() hideAllowedAmount: boolean;

  ClaimType = ClaimType;
  linkExpenseIsOpen = false;

  beforeMount () {
    this.claimStore.initializeLinkedExpensesState(this.claim.claimNumber);
  }

  mounted () {
    this.claimStore.loadLinkedExpenses(this.claim.claimNumber);
  }

  claimNumberWithLine (lineNumber: number): string {
    if (lineNumber === null || lineNumber === undefined || lineNumber <= 0) {
      return this.claim.claimNumber;
    }
    return this.claim.claimNumber + "-" + lineNumber;
  }

  get formattedServiceDate (): string {
    return moment(this.claim.serviceDate).format("MMM D, YYYY");
  }

  handleClaimExpense () {
    this.onClaimExpenseLink(this.claim.claimNumber);
  }

  toggleLinkExpense (): void {
    this.linkExpenseIsOpen = !this.linkExpenseIsOpen;
  }

  onClose () {
    this.linkExpenseIsOpen = false;
  }

  get linkedExpensesLoaded (): boolean {
    return this.claimStore.linkedExpensesFetchState(this.claim.claimNumber) === FetchState.Loaded;
  }

  get hasLinkedExpenses (): boolean {
    return this.claimStore.linkedExpenses(this.claim.claimNumber)
        && this.claimStore.linkedExpenses(this.claim.claimNumber).length > 0;
  }
}
